require("jquery");
require("popper");
require("bootstrap");
require("@rails/activestorage").start();
require("plugins/graphql_chart");
require("plugins/copy_on_click");
require("docs");
require("ui-kit");

window.RailsUJS = require("@rails/ujs");
RailsUJS.start();

// Stimulus (Hotwire) — boots the Stimulus app and autoloads controllers.
// See app/javascript/controllers/index.js
require("controllers");

// Turbo (Hotwire) — successor to Turbolinks. Imported AFTER rails-ujs so that
// rails-ujs keeps handling the existing data-method / data-confirm links: its
// click handler registers first and preventDefaults, so Turbo Drive defers.
require("@hotwired/turbo-rails");
// Keep form submissions on the classic Rails path for now (Turbo would otherwise
// require form error responses to be 422). Turbo Drive navigation stays enabled;
// revisit per-feature (e.g. Turbo Frames for variant editing) later.
if (window.Turbo && window.Turbo.setFormMode) window.Turbo.setFormMode("off");
